import { Component, Input } from '@angular/core';

@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
})
export class EmptyStateComponent {
  @Input() public emojiPathUrl?: string;

  @Input() public illustrationPathUrl?: string;

  @Input() public title?: string;

  @Input() public msg?: string;
}
